
import { computed, defineComponent } from "vue";
import { NAVIGATION_LINKS } from "@/constants/navigationLinks";

export default defineComponent({
  name: "NavigationDrawer",
  props: {
    toggleOpenMenu: Function,
    openMenu: Boolean,
  },
  setup(props) {
    const isOpen = computed(() => {
      return props.openMenu;
    });
    return {
      isOpen,
      NAVIGATION_LINKS,
    };
  },
});
